module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0032.jpg?v=5644011d";